module.exports = __webpack_public_path__ + "static/media/image-24px.544172b7.svg";